import _ from 'lodash';
import {
    FETCH_AI_MAILER_THREADS,
    CLEAN_AI_MAILER_THREADS,
    DELETE_AI_MAILER_THREAD,
    DELETE_AI_MAILER_THREADS,
    IGNORE_AI_MAILER_THREAD,
    UNIGNORE_AI_MAILER_THREAD,
} from './types';
import { request, __ } from '../functions';

export const fetchAiMailerThreads = (screen, options = {}) => {
    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request('/ai-mailer-threads', params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        // Nasetujeme user data
        setUser(sync.user);

        dispatch({ type: FETCH_AI_MAILER_THREADS, payload: data });
    });
};

export const deleteAiMailerThread = (screen, id) => {
    return dispatch => request(`/ai-mailer-threads/delete/${id}`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zmazať konverzáciu'));
            return;
        }

        screen.showSnackbar('success', __('Konverzácia bola zmazaná'));

        dispatch({ type: DELETE_AI_MAILER_THREAD });
    });
};

export const deleteAiMailerThreads = (screen, ids, filtered = {}) => {
    let params = {};

    // Nasetujeme filter
    _.forEach(filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request(`/ai-mailer-threads/multiDelete/${ids}`, params).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zmazať konverzácie'));
            return;
        }

        screen.showSnackbar('success', __('Konverzácie boli zmazané'));

        dispatch({ type: DELETE_AI_MAILER_THREADS });
    });
};

export const ignoreAiMailerThread = (screen, id) => {
    return dispatch => request(`/ai-mailer-threads/ignore/${id}`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa ignorovať konverzáciu'));
            return;
        }

        screen.showSnackbar('success', __('Konverzácia bola označená ako ignorovaná'));

        dispatch({ type: IGNORE_AI_MAILER_THREAD, payload: id });
    });
};

export const unignoreAiMailerThread = (screen, id) => {
    return dispatch => request(`/ai-mailer-threads/unignore/${id}`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zrušiť ignoráciu konverzácii'));
            return;
        }

        screen.showSnackbar('success', __('Konverzácia bola zrušená ako ignorovaná'));

        dispatch({ type: UNIGNORE_AI_MAILER_THREAD, payload: id });
    });
};

export const cleanAiMailerThreads = () => ({ type: CLEAN_AI_MAILER_THREADS });
